// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".formulate-input-errors{color:red}.chat-user-selector-table .v-data-footer{padding:0;justify-content:center}.chat-user-selector-table .v-data-footer .v-data-footer__select{margin-left:0;margin-right:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
